import { ccv2Fetch } from './index';

/** @param {boolean} includeInactive @returns {Promise<Array>} */
export const fetchWorkSchedules = (includeInactive = false) =>
  ccv2Fetch(`/v2/callcenter/work-schedules${includeInactive ? '?includeInactive=true' : ''}`);

/** @param {number} id @returns {Promise<Object>} */
export const fetchWorkSchedule = (id) => ccv2Fetch(`/v2/callcenter/work-schedules/${id}`);

/** @param {Object} dto @returns {Promise<Object>} */
export const createWorkSchedule = (dto) =>
  ccv2Fetch('/v2/callcenter/work-schedules', { method: 'POST', body: JSON.stringify(dto) });

/** @param {number} id @param {Object} dto @returns {Promise<Object>} */
export const updateWorkSchedule = (id, dto) =>
  ccv2Fetch(`/v2/callcenter/work-schedules/${id}`, { method: 'PUT', body: JSON.stringify(dto) });

/** @param {number} id @returns {Promise<null>} */
export const deleteWorkSchedule = (id) =>
  ccv2Fetch(`/v2/callcenter/work-schedules/${id}`, { method: 'DELETE' });

/** @param {number} id @returns {Promise<Array>} */
export const fetchIntervals = (id) => ccv2Fetch(`/v2/callcenter/work-schedules/${id}/intervals`);

/** @param {number} id @param {{ dayOfWeek: number, startTime: string, endTime: string }} dto */
export const addInterval = (id, dto) =>
  ccv2Fetch(`/v2/callcenter/work-schedules/${id}/intervals`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });

/** @param {number} id @param {number} intervalId */
export const removeInterval = (id, intervalId) =>
  ccv2Fetch(`/v2/callcenter/work-schedules/${id}/intervals/${intervalId}`, { method: 'DELETE' });

/** @param {number} id @returns {Promise<Array>} */
export const fetchOverrides = (id) => ccv2Fetch(`/v2/callcenter/work-schedules/${id}/overrides`);

/** @param {number} id @param {{ date: string, isWorking: boolean, startTime?: string, endTime?: string, reason?: string }} dto */
export const addOverride = (id, dto) =>
  ccv2Fetch(`/v2/callcenter/work-schedules/${id}/overrides`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });

/** @param {number} id @param {number} overrideId */
export const removeOverride = (id, overrideId) =>
  ccv2Fetch(`/v2/callcenter/work-schedules/${id}/overrides/${overrideId}`, { method: 'DELETE' });
